/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Go Chat Auth API
 * API for frontend and mobile apps
 * OpenAPI spec version: 1.0
 */
import { faker } from '@faker-js/faker';

import { HttpResponse, delay, http } from 'msw';
import type { RequestHandlerOptions } from 'msw';

import { createIntegrationsInstance } from '../../api-instance';
import type { BodyType } from '../../api-instance';
export interface HandlersPipelinesResponse {
  pipelines?: ModelsPipeline[];
  status?: string;
}

/**
 * Упрощенное представление интеграции между CRM и GOCHAT аккаунтом
 */
export interface HandlersSimplifiedAccountChain {
  /** CompanyId - идентификатор компании. (required)
Может быть nil если компания не привязана.
Пример: "comp_123456" */
  company_id: string;
  /** CompanyName - название компании.
Опциональное поле, может быть пустым.
Пример: "ООО Ромашка" */
  company_name?: string;
  /** CRMAccountId - идентификатор аккаунта в CRM системе. (required)
Может быть числовым или строковым идентификатором.
Пример: "12345" */
  crm_account_id: string;
  /** CRMDomain - домен CRM системы. (required)
Пример: "example.amocrm.ru" */
  crm_domain: string;
  /** ProviderType - тип CRM провайдера.
Пример: "amocrm" */
  provider_type?: string;
  /** GOCHAT Account ID - идентификатор аккаунта в системе GOCHAT в формате UUID. (required)
Пример: "6ba7b810-9dad-11d1-80b4-00c04fd430c8" */
  gochat_account_id: string;
  /** IntegraId - уникальный идентификатор интеграции в формате UUID. (required)
Пример: "550e8400-e29b-41d4-a716-446655440000" */
  integra_id: string;
  /** IsActive - флаг активности аккаунта в системе. (required)
Определяет, может ли аккаунт использоваться в операциях.
Пример: true */
  is_active: boolean;
  /** Status - текущий статус аккаунта. (required)
true - активен, false - неактивен.
Пример: true */
  status: boolean;
}

/**
 * Модель источника из AMO CRM
 */
export interface HandlersSource {
  default?: boolean;
  external_id?: string;
  id?: number;
  is_error?: boolean;
  name?: string;
  origin_code?: string;
  pipeline_id?: number;
}

export interface HandlersSourcesResponse {
  sources?: HandlersSource[];
  status?: string;
}

export interface ModelsError {
  code?: string;
  details?: string;
}

/**
 * Модель воронки из AMO CRM
 */
export interface ModelsPipeline {
  id?: number;
  is_archive?: boolean;
  is_main?: boolean;
  is_unsorted_on?: boolean;
  name?: string;
  sort?: number;
  statuses?: ModelsStatus[];
}

/**
 * Модель статуса воронки (1 – неразобранное, 0 – обычный статус)
 */
export interface ModelsStatus {
  color?: string;
  id?: number;
  name?: string;
  sort?: number;
  type?: number;
}

export interface TypesChannelBindingFullResponse {
  companies?: TypesChannelBindingResponse[];
  current_company?: string;
  group_chats_enabled?: boolean;
  not_companies?: TypesChannelBindingSimple[];
}

export interface TypesChannelBindingResponse {
  bindings?: TypesChannelBindingSimple[];
  company_id?: string;
  company_name?: string;
}

export interface TypesChannelBindingSimple {
  binding_status?: boolean;
  channel_id?: string;
  channel_name?: string;
  channel_status?: boolean;
  pipeline_id?: number;
  pipeline_status?: number;
  protocol?: string;
  status?: string;
}

export interface TypesChannelBindingUpdate {
  binding_status?: boolean;
  channel_id?: string;
  channel_status?: boolean;
  pipeline_id?: number;
  pipeline_status?: number;
}

export interface TypesUpdateBindingsRequest {
  bindings: TypesChannelBindingUpdate[];
  company_id?: string;
}

export interface TypesUpdateBindingsResponse {
  status?: string;
  updated?: number;
}

/**
 * Запрос для обновления статуса активности интеграции
 */
export interface TypesUpdateIsActiveRequest {
  /** AmoJoID идентификатор аккаунта в AMO (может быть числовым ID или UUID)
@Example "90573b74-8bf1-4220-89dd-7bea252521f3"
@Required true */
  crm_account_id: string;
  /** ProviderType - тип CRM провайдера.
@Example "amocrm" */
  provider_type?: string;
  /** IsActive флаг активности
@Example false */
  is_active?: boolean;
}

export type PutApiV2IntegrationsGochatAccountId200 = {
  is_active?: boolean;
  message?: string;
  status?: string;
  updated_channels?: number;
};

export type DeleteApiV2IntegrationsIntegraId200 = {
  status?: string;
};

export type PostApiV2WidgetLinkAccountsBodyLetsgochat = {
  account_id?: string;
};

export type PostApiV2WidgetLinkAccountsBody = {
  amojo_id?: string;
  client_id?: string;
  letsgochat?: PostApiV2WidgetLinkAccountsBodyLetsgochat;
};

export type PostApiV2WidgetLinkAccounts200Data = {
  account_id?: string;
  amojo_id?: string;
  client_id?: string;
};

export type PostApiV2WidgetLinkAccounts200 = {
  data?: PostApiV2WidgetLinkAccounts200Data;
  status?: string;
};

export type GetApiV2WidgetPipelinesParams = {
  /**
   * AMOJO идентификатор аккаунта
   */
  amojo_id: string;
};

export type GetApiV2WidgetSourcesParams = {
  /**
   * AMOJO идентификатор аккаунта
   */
  amojo_id: string;
};

export type PostApiV2WidgetUnlinkAccountsBodyLetsgochat = {
  account_id?: string;
};

export type PostApiV2WidgetUnlinkAccountsBody = {
  amojo_id?: string;
  letsgochat?: PostApiV2WidgetUnlinkAccountsBodyLetsgochat;
};

export type PostApiV2WidgetUnlinkAccounts200Data = {
  amojo_id?: string;
};

export type PostApiV2WidgetUnlinkAccounts200 = {
  data?: PostApiV2WidgetUnlinkAccounts200Data;
  message?: string;
  status?: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Возвращает список всех привязок каналов для указанного amojo_id с группировкой по компаниям
 * @summary Получить привязки каналов
 */
export const getApiV2ChannelBindingsAmojoId = (
  amojoId: string,
  options?: SecondParameter<
    typeof createIntegrationsInstance<TypesChannelBindingFullResponse>
  >
) => {
  return createIntegrationsInstance<TypesChannelBindingFullResponse>(
    { url: `/api/v2/channel-bindings/${amojoId}`, method: 'GET' },
    options
  );
};

/**
 * Обновляет или создает привязки каналов для указанного amojo_id
 * @summary Обновить привязки каналов
 */
export const putApiV2ChannelBindingsAmojoId = (
  amojoId: string,
  typesUpdateBindingsRequest: BodyType<TypesUpdateBindingsRequest>,
  options?: SecondParameter<
    typeof createIntegrationsInstance<TypesUpdateBindingsResponse>
  >
) => {
  return createIntegrationsInstance<TypesUpdateBindingsResponse>(
    {
      url: `/api/v2/channel-bindings/${amojoId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: typesUpdateBindingsRequest,
    },
    options
  );
};

/**
 * Возвращает список интеграций по идентификатору аккаунта GOCHAT. Если интеграции не найдены, возвращает пустой массив.
 * @summary Получить интеграции по GOCHAT Account ID
 */
export const getApiV2IntegrationsGochatAccountId = (
  gochatAccountId: string,
  options?: SecondParameter<
    typeof createIntegrationsInstance<HandlersSimplifiedAccountChain[]>
  >
) => {
  return createIntegrationsInstance<HandlersSimplifiedAccountChain[]>(
    { url: `/api/v2/integrations/${gochatAccountId}`, method: 'GET' },
    options
  );
};

/**
 * Обновляет поле is_active для интеграции и отключает/включает все связанные каналы
 * @summary Обновить статус активности интеграции и каналов
 */
export const putApiV2IntegrationsGochatAccountId = (
  gochatAccountId: string,
  typesUpdateIsActiveRequest: BodyType<TypesUpdateIsActiveRequest>,
  options?: SecondParameter<
    typeof createIntegrationsInstance<PutApiV2IntegrationsGochatAccountId200>
  >
) => {
  return createIntegrationsInstance<PutApiV2IntegrationsGochatAccountId200>(
    {
      url: `/api/v2/integrations/${gochatAccountId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: typesUpdateIsActiveRequest,
    },
    options
  );
};

/**
 * Удаляет НЕактивную интеграцию и связанные данные (привязки каналов, маппинги пользователей, атрибуции диалогов). Активную интеграцию нужно сначала выключить, привязанную к профилю — отвязать в настройках профиля.
 * @summary Удалить неактивную интеграцию
 */
export const deleteApiV2IntegrationsIntegraId = (
  integraId: string,
  options?: SecondParameter<
    typeof createIntegrationsInstance<DeleteApiV2IntegrationsIntegraId200>
  >
) => {
  return createIntegrationsInstance<DeleteApiV2IntegrationsIntegraId200>(
    { url: `/api/v2/integrations/${integraId}`, method: 'DELETE' },
    options
  );
};

/**
 * Создает связь между аккаунтом GOCHAT и аккаунтом AMO CRM
 * @summary Связать аккаунты GOCHAT и AMO
 */
export const postApiV2WidgetLinkAccounts = (
  postApiV2WidgetLinkAccountsBody: BodyType<PostApiV2WidgetLinkAccountsBody>,
  options?: SecondParameter<
    typeof createIntegrationsInstance<PostApiV2WidgetLinkAccounts200>
  >
) => {
  return createIntegrationsInstance<PostApiV2WidgetLinkAccounts200>(
    {
      url: `/api/v2/widget/link-accounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postApiV2WidgetLinkAccountsBody,
    },
    options
  );
};

/**
 * Возвращает список воронок для указанного аккаунта AMO CRM
 * @summary Получить воронки по AMOJO ID
 */
export const getApiV2WidgetPipelines = (
  params: GetApiV2WidgetPipelinesParams,
  options?: SecondParameter<
    typeof createIntegrationsInstance<HandlersPipelinesResponse>
  >
) => {
  return createIntegrationsInstance<HandlersPipelinesResponse>(
    { url: `/api/v2/widget/pipelines`, method: 'GET', params },
    options
  );
};

/**
 * Возвращает список источников для указанного аккаунта AMO CRM
 * @summary Получить источники по AMOJO ID
 */
export const getApiV2WidgetSources = (
  params: GetApiV2WidgetSourcesParams,
  options?: SecondParameter<
    typeof createIntegrationsInstance<HandlersSourcesResponse>
  >
) => {
  return createIntegrationsInstance<HandlersSourcesResponse>(
    { url: `/api/v2/widget/sources`, method: 'GET', params },
    options
  );
};

/**
 * Удаляет связь между аккаунтом GOCHAT и аккаунтом AMO CRM
 * @summary Отвязать аккаунты GOCHAT от AMO
 */
export const postApiV2WidgetUnlinkAccounts = (
  postApiV2WidgetUnlinkAccountsBody: BodyType<PostApiV2WidgetUnlinkAccountsBody>,
  options?: SecondParameter<
    typeof createIntegrationsInstance<PostApiV2WidgetUnlinkAccounts200>
  >
) => {
  return createIntegrationsInstance<PostApiV2WidgetUnlinkAccounts200>(
    {
      url: `/api/v2/widget/unlink-accounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postApiV2WidgetUnlinkAccountsBody,
    },
    options
  );
};

export type GetApiV2ChannelBindingsAmojoIdResult = NonNullable<
  Awaited<ReturnType<typeof getApiV2ChannelBindingsAmojoId>>
>;
export type PutApiV2ChannelBindingsAmojoIdResult = NonNullable<
  Awaited<ReturnType<typeof putApiV2ChannelBindingsAmojoId>>
>;
export type GetApiV2IntegrationsGochatAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof getApiV2IntegrationsGochatAccountId>>
>;
export type PutApiV2IntegrationsGochatAccountIdResult = NonNullable<
  Awaited<ReturnType<typeof putApiV2IntegrationsGochatAccountId>>
>;
export type DeleteApiV2IntegrationsIntegraIdResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiV2IntegrationsIntegraId>>
>;
export type PostApiV2WidgetLinkAccountsResult = NonNullable<
  Awaited<ReturnType<typeof postApiV2WidgetLinkAccounts>>
>;
export type GetApiV2WidgetPipelinesResult = NonNullable<
  Awaited<ReturnType<typeof getApiV2WidgetPipelines>>
>;
export type GetApiV2WidgetSourcesResult = NonNullable<
  Awaited<ReturnType<typeof getApiV2WidgetSources>>
>;
export type PostApiV2WidgetUnlinkAccountsResult = NonNullable<
  Awaited<ReturnType<typeof postApiV2WidgetUnlinkAccounts>>
>;

export const getGetApiV2ChannelBindingsAmojoIdResponseMock = (
  overrideResponse: Partial<TypesChannelBindingFullResponse> = {}
): TypesChannelBindingFullResponse => ({
  companies: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      bindings: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => ({
          binding_status: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          channel_id: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          channel_name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          channel_status: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined,
          ]),
          pipeline_id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          pipeline_status: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          protocol: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          status: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
        })),
        undefined,
      ]),
      company_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      company_name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  current_company: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  group_chats_enabled: faker.helpers.arrayElement([
    faker.datatype.boolean(),
    undefined,
  ]),
  not_companies: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      binding_status: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      channel_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      channel_name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      channel_status: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      pipeline_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      pipeline_status: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      protocol: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      status: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPutApiV2ChannelBindingsAmojoIdResponseMock = (
  overrideResponse: Partial<TypesUpdateBindingsResponse> = {}
): TypesUpdateBindingsResponse => ({
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  updated: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetApiV2IntegrationsGochatAccountIdResponseMock =
  (): HandlersSimplifiedAccountChain[] =>
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      company_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
      company_name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      crm_account_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
      crm_domain: faker.string.alpha({ length: { min: 10, max: 20 } }),
      provider_type: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      gochat_account_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
      integra_id: faker.string.alpha({ length: { min: 10, max: 20 } }),
      is_active: faker.datatype.boolean(),
      status: faker.datatype.boolean(),
    }));

export const getPutApiV2IntegrationsGochatAccountIdResponseMock = (
  overrideResponse: Partial<PutApiV2IntegrationsGochatAccountId200> = {}
): PutApiV2IntegrationsGochatAccountId200 => ({
  is_active: faker.helpers.arrayElement([faker.datatype.boolean(), undefined]),
  message: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  updated_channels: faker.helpers.arrayElement([
    faker.number.int({ min: undefined, max: undefined }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getDeleteApiV2IntegrationsIntegraIdResponseMock = (
  overrideResponse: Partial<DeleteApiV2IntegrationsIntegraId200> = {}
): DeleteApiV2IntegrationsIntegraId200 => ({
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPostApiV2WidgetLinkAccountsResponseMock = (
  overrideResponse: Partial<PostApiV2WidgetLinkAccounts200> = {}
): PostApiV2WidgetLinkAccounts200 => ({
  data: faker.helpers.arrayElement([
    {
      account_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      amojo_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      client_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
    },
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetApiV2WidgetPipelinesResponseMock = (
  overrideResponse: Partial<HandlersPipelinesResponse> = {}
): HandlersPipelinesResponse => ({
  pipelines: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      is_archive: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_main: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      is_unsorted_on: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      sort: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      statuses: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => ({
          color: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          id: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          name: faker.helpers.arrayElement([
            faker.string.alpha({ length: { min: 10, max: 20 } }),
            undefined,
          ]),
          sort: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
          type: faker.helpers.arrayElement([
            faker.number.int({ min: undefined, max: undefined }),
            undefined,
          ]),
        })),
        undefined,
      ]),
    })),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetApiV2WidgetSourcesResponseMock = (
  overrideResponse: Partial<HandlersSourcesResponse> = {}
): HandlersSourcesResponse => ({
  sources: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      default: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      external_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
      is_error: faker.helpers.arrayElement([
        faker.datatype.boolean(),
        undefined,
      ]),
      name: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      origin_code: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
      pipeline_id: faker.helpers.arrayElement([
        faker.number.int({ min: undefined, max: undefined }),
        undefined,
      ]),
    })),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getPostApiV2WidgetUnlinkAccountsResponseMock = (
  overrideResponse: Partial<PostApiV2WidgetUnlinkAccounts200> = {}
): PostApiV2WidgetUnlinkAccounts200 => ({
  data: faker.helpers.arrayElement([
    {
      amojo_id: faker.helpers.arrayElement([
        faker.string.alpha({ length: { min: 10, max: 20 } }),
        undefined,
      ]),
    },
    undefined,
  ]),
  message: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  status: faker.helpers.arrayElement([
    faker.string.alpha({ length: { min: 10, max: 20 } }),
    undefined,
  ]),
  ...overrideResponse,
});

export const getGetApiV2ChannelBindingsAmojoIdMockHandler = (
  overrideResponse?:
    | TypesChannelBindingFullResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<TypesChannelBindingFullResponse>
        | TypesChannelBindingFullResponse),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v2/channel-bindings/:amojoId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetApiV2ChannelBindingsAmojoIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getPutApiV2ChannelBindingsAmojoIdMockHandler = (
  overrideResponse?:
    | TypesUpdateBindingsResponse
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) => Promise<TypesUpdateBindingsResponse> | TypesUpdateBindingsResponse),
  options?: RequestHandlerOptions
) => {
  return http.put(
    '*/api/v2/channel-bindings/:amojoId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPutApiV2ChannelBindingsAmojoIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetApiV2IntegrationsGochatAccountIdMockHandler = (
  overrideResponse?:
    | HandlersSimplifiedAccountChain[]
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) =>
        | Promise<HandlersSimplifiedAccountChain[]>
        | HandlersSimplifiedAccountChain[]),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v2/integrations/:gochatAccountId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetApiV2IntegrationsGochatAccountIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getPutApiV2IntegrationsGochatAccountIdMockHandler = (
  overrideResponse?:
    | PutApiV2IntegrationsGochatAccountId200
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0]
      ) =>
        | Promise<PutApiV2IntegrationsGochatAccountId200>
        | PutApiV2IntegrationsGochatAccountId200),
  options?: RequestHandlerOptions
) => {
  return http.put(
    '*/api/v2/integrations/:gochatAccountId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPutApiV2IntegrationsGochatAccountIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getDeleteApiV2IntegrationsIntegraIdMockHandler = (
  overrideResponse?:
    | DeleteApiV2IntegrationsIntegraId200
    | ((
        info: Parameters<Parameters<typeof http.delete>[1]>[0]
      ) =>
        | Promise<DeleteApiV2IntegrationsIntegraId200>
        | DeleteApiV2IntegrationsIntegraId200),
  options?: RequestHandlerOptions
) => {
  return http.delete(
    '*/api/v2/integrations/:integraId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getDeleteApiV2IntegrationsIntegraIdResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getPostApiV2WidgetLinkAccountsMockHandler = (
  overrideResponse?:
    | PostApiV2WidgetLinkAccounts200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) =>
        | Promise<PostApiV2WidgetLinkAccounts200>
        | PostApiV2WidgetLinkAccounts200),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v2/widget/link-accounts',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostApiV2WidgetLinkAccountsResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetApiV2WidgetPipelinesMockHandler = (
  overrideResponse?:
    | HandlersPipelinesResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<HandlersPipelinesResponse> | HandlersPipelinesResponse),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v2/widget/pipelines',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetApiV2WidgetPipelinesResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getGetApiV2WidgetSourcesMockHandler = (
  overrideResponse?:
    | HandlersSourcesResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0]
      ) => Promise<HandlersSourcesResponse> | HandlersSourcesResponse),
  options?: RequestHandlerOptions
) => {
  return http.get(
    '*/api/v2/widget/sources',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetApiV2WidgetSourcesResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};

export const getPostApiV2WidgetUnlinkAccountsMockHandler = (
  overrideResponse?:
    | PostApiV2WidgetUnlinkAccounts200
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0]
      ) =>
        | Promise<PostApiV2WidgetUnlinkAccounts200>
        | PostApiV2WidgetUnlinkAccounts200),
  options?: RequestHandlerOptions
) => {
  return http.post(
    '*/api/v2/widget/unlink-accounts',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getPostApiV2WidgetUnlinkAccountsResponseMock()
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      );
    },
    options
  );
};
export const getGoChatAuthAPIMock = () => [
  getGetApiV2ChannelBindingsAmojoIdMockHandler(),
  getPutApiV2ChannelBindingsAmojoIdMockHandler(),
  getGetApiV2IntegrationsGochatAccountIdMockHandler(),
  getPutApiV2IntegrationsGochatAccountIdMockHandler(),
  getDeleteApiV2IntegrationsIntegraIdMockHandler(),
  getPostApiV2WidgetLinkAccountsMockHandler(),
  getGetApiV2WidgetPipelinesMockHandler(),
  getGetApiV2WidgetSourcesMockHandler(),
  getPostApiV2WidgetUnlinkAccountsMockHandler(),
];
